import {BaseEntity} from '../../app-common/data/BaseEntity';

export class MailCheck extends BaseEntity<number> {
  communicationId: number;
  check: string;
  payable: string;
  amount: number;
  memo: string;
}
